document.addEventListener('DOMContentLoaded', function () {
  const target = document.querySelector('.m-estimated-delivery-date');
  if (!target) return;

  // Settings (match your theme defaults)
  const deliveryDays = 2; // deliver_days
  const rangeDays = 1;    // +/- 1 days

  const today = new Date();

  const fromDate = new Date(today);
  fromDate.setDate(today.getDate() + deliveryDays - rangeDays);

  const toDate = new Date(today);
  toDate.setDate(today.getDate() + deliveryDays + rangeDays);

  // Spanish month names (Argentina style)
  const monthsES = [
    'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
    'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
  ];

  function formatDateES(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = monthsES[date.getMonth()];
    return `${month} ${day}`;
  }

  const fromFormatted = formatDateES(fromDate);
  const toFormatted = formatDateES(toDate);

  target.textContent = `${fromFormatted} - ${toFormatted}`;
});
